var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 50 50","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M25 42c-9.4 0-17-7.6-17-17S15.6 8 25 8s17 7.6 17 17-7.6 17-17 17zm0-32c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15z"}},{"tag":"path","attr":{"d":"M32.283 16.302l1.414 1.415-15.98 15.98-1.414-1.414z"}},{"tag":"path","attr":{"d":"M17.717 16.302l15.98 15.98-1.414 1.415-15.98-15.98z"}}]})(props);
};
